export default "/images/b2126e843a024289c19f9fa40fbf9d6b.png";